import type { Command } from 'commander';
import { deleteCredentials, getCredentialsPath } from '../../lib/credentials-store';

export function registerEnterpriseLogout(parent: Command): void {
	parent
		.command('logout')
		.description('Delete the saved enterprise API key')
		.action(() => {
			const deleted = deleteCredentials();
			process.stdout.write(
				deleted ? `Logged out. Removed ${getCredentialsPath()}\n` : 'No saved credentials to remove.\n'
			);
		});
}
